import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuPaciente extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/paciente/consulta" className="nav-link">
          <i className="link-icon icon-user" />
          <span className="menu-title">Paciente</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/paciente/consulta">
                Consultar
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={{ pathname: "/paciente/cadastro", state: "refresh" }}>
                Novo Cadastro
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuPaciente;
